import React, { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  TextField,
  Typography
} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Box } from '@mui/system';
import { useLocation } from 'react-router-dom';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';

import { CommonApiforJourney } from '../../JourneyApi';
import useJourneySelector from '../../../../store/Slice/Journey/JourneySelector';
import useLoginSelector from '../../../../store/Slice/Login/LoginSelector';

export default function AddJourney1({ handleNext }) {
  const [journeyStateData, setJourneyStateData] = useState({
    journeyDetails: {
      userId: null,
      companyId: null,
      journeyId: null,
      journeyName: null,
      parentLoanId: null,
      parentLoanName: ' ',
      loanSubTypeId: null,
      loanSubTypeName: ' ',
      journeyIsActive: false,
      journeyIsPublish: false,
      employmentCategoryId: null,
      employmentCategoryName: ' ',
      employmentSubTypeId: null,
      employmentSubTypeName: ' ',
      journeyTypeId: null,
      journeyTypeName: ' ',
      targetAudienceTypeId: null,
      targetAudienceName: ' ',
      journeyType: [],
      targetAudience: [],
      loanType: [],
      loanSubType: [],
      employmentType: [],
      employmentSubType: [],
      errorMessage: null,
      errorPopUp: false,
      journeyDeploymentModeType: [],
      journeyDeploymentModeTypeId: null,
      journeyDeploymentModeTypeName: ''
    }
  });

  const { LoginData } = useLoginSelector();
  const { JourneyEdit } = useJourneySelector();

  const location = useLocation();
  const { pageType } = location?.state || {};

  useEffect(() => {
    const cardTypeListAll = localStorage.getItem('cardTypeListAll');
    if (cardTypeListAll === null || cardTypeListAll === undefined) {
      loantyprapiFire('cardTypeList', 'get');
    }
    loantyprapiFire('loanType', null);
    loantyprapiFire('employmentType', null);
    loantyprapiFire('journeyType', 'get');
    loantyprapiFire('audienceType', 'get');
  }, []);

  useEffect(() => {
    if (JourneyEdit !== null && pageType === 'Edit') {
      loantyprapiFire('loanSubType', JourneyEdit?.journeyModel?.loanTypeId);
      loantyprapiFire('employmentSubType', JourneyEdit?.journeyModel?.employmentTypeId);
      const prevData = journeyStateData.journeyDetails;
      prevData.userId = JourneyEdit?.userId;
      prevData.companyId = JourneyEdit?.companyId;
      prevData.journeyIsActive = JourneyEdit?.journeyModel?.journeyIsActive;
      prevData.journeyIsPublish = JourneyEdit?.journeyModel?.journeyIsPublish;
      prevData.journeyId = JourneyEdit?.journeyModel?.journeyId;
      prevData.journeyName = JourneyEdit?.journeyModel?.journeyName;
      prevData.parentLoanId = JourneyEdit?.journeyModel?.loanTypeId;
      prevData.parentLoanName = JSON.stringify(JourneyEdit?.journeyModel?.loanType);
      prevData.loanSubTypeId = JourneyEdit?.journeyModel?.loanSubTypeId;
      prevData.loanSubTypeName = JSON.stringify(JourneyEdit?.journeyModel?.loanSubType);
      prevData.employmentCategoryId = JourneyEdit?.journeyModel?.employmentTypeId;
      prevData.employmentCategoryName = JSON.stringify(JourneyEdit?.journeyModel?.employmentType);
      prevData.employmentSubTypeId = JourneyEdit?.journeyModel?.employmentSubTypeId;
      prevData.employmentSubTypeName = JSON.stringify(JourneyEdit?.journeyModel?.employmentSubType);
      prevData.journeyTypeId = JourneyEdit?.journeyModel?.journeyTypeId;
      prevData.journeyTypeName = JSON.stringify(JourneyEdit?.journeyModel?.journeyType);
      prevData.targetAudienceTypeId = JourneyEdit?.journeyModel?.targetAudienceTypeId;
      prevData.targetAudienceName = JSON.stringify(JourneyEdit?.journeyModel?.targetAudienceType);

      if (
        JourneyEdit?.journeyModel?.journeyDeploymentModeType !== null &&
        JourneyEdit?.journeyModel?.journeyDeploymentModeType !== undefined
      ) {
        prevData.journeyDeploymentModeType.push(
          JourneyEdit?.journeyModel?.journeyDeploymentModeType
        );
      }

      prevData.journeyDeploymentModeTypeId = JourneyEdit?.journeyModel?.journeyDeploymentModeTypeId;
      prevData.journeyDeploymentModeTypeName = JSON.stringify(
        JourneyEdit?.journeyModel?.journeyDeploymentModeType
      );

      setJourneyStateData({
        ...journeyStateData,
        journeyDetails: prevData
      });
    }
  }, [JourneyEdit, pageType]);

  const loantyprapiFire = useCallback(
    async (type, condition) => {
      const companyIdObj = {
        companyId: LoginData?.companyId,
        userId: LoginData?.userId
      };
      let methodName = '';
      let endapiPath = '';
      const token = LoginData?.jwt;

      if (type === 'cardTypeList') {
        methodName = 'GET';
        endapiPath = 'journey/master/types/journey-card-type';
      } else if (type === 'cardTypeName') {
        if (condition !== null) {
          const conditionObj = JSON.parse(condition);
          companyIdObj.cardTypeId = conditionObj.typeId;
          companyIdObj.wizardId = conditionObj.wizardId;
          methodName = 'POST';
          endapiPath = 'journey/master/card-by-types';
        }
      } else if (type === 'cardNameList') {
        if (condition !== null) {
          const conditionObj = JSON.parse(condition);
          companyIdObj.cardMasterId = conditionObj.cardMasterId;
          companyIdObj.journeyCardId = conditionObj.journeyCardId;
          methodName = 'POST';
          endapiPath = 'journey/master/card-fields-by-card';
        }
      } else if (type === 'loanType') {
        companyIdObj.returnConfiguredTypesOnly = true;
        methodName = 'POST';
        endapiPath = 'company/parent-loan-masters/list';
      } else if (type === 'loanSubType') {
        if (condition !== null) {
          companyIdObj.parentLoanId = condition;
          companyIdObj.returnConfiguredTypesOnly = true;
          methodName = 'POST';
          endapiPath = 'company/loan-masters/list';
        }
      } else if (type === 'employmentType') {
        companyIdObj.returnConfiguredTypesOnly = true;
        methodName = 'POST';
        endapiPath = 'company/parent-emp-types/list';
      } else if (type === 'employmentSubType') {
        if (condition !== null) {
          companyIdObj.returnConfiguredTypesOnly = true;
          companyIdObj.employmentCategoryId = condition;
          methodName = 'POST';
          endapiPath = 'company/emp-types/list';
        }
      } else if (type === 'journeySave') {
        const prevData = journeyStateData.journeyDetails;

        if (journeyStateData.journeyDetails.journeyName === null) {
          prevData.errorMessage = 'Journey Name';
          prevData.errorPopUp = true;
        } else if (journeyStateData.journeyDetails.parentLoanName === ' ') {
          prevData.errorMessage = 'Loan Type';
          prevData.errorPopUp = true;
        } else if (journeyStateData.journeyDetails.loanSubTypeName === ' ') {
          prevData.errorMessage = 'Loan Sub Type';
          prevData.errorPopUp = true;
        } else if (journeyStateData.journeyDetails.employmentCategoryName === ' ') {
          prevData.errorMessage = 'Employment Type';
          prevData.errorPopUp = true;
        } else if (journeyStateData.journeyDetails.employmentSubTypeName === ' ') {
          prevData.errorMessage = 'Employment Sub Type';
          prevData.errorPopUp = true;
        } else if (journeyStateData.journeyDetails.journeyTypeName === ' ') {
          prevData.errorMessage = 'Journey Type';
          prevData.errorPopUp = true;
        } else if (
          journeyStateData.journeyDetails.journeyTypeName &&
          JSON.stringify(journeyStateData.journeyDetails.journeyTypeName).typeCode ===
            'RECOMMENDATION' &&
          (journeyStateData.journeyDetails.journeyDeploymentModeTypeName === undefined ||
            journeyStateData.journeyDetails.journeyDeploymentModeTypeName === null ||
            journeyStateData.journeyDetails.journeyDeploymentModeTypeName.trim() === '')
        ) {
          prevData.errorMessage = 'Journey Deployment Mode is not selected';
          prevData.errorPopUp = true;
        } else if (journeyStateData.journeyDetails.targetAudienceName === ' ') {
          prevData.errorMessage = 'Target Audience';
          prevData.errorPopUp = true;
        }

        setJourneyStateData({
          ...journeyStateData,
          journeyDetails: prevData
        });

        if (journeyStateData.journeyDetails.errorMessage === null) {
          companyIdObj.journeyId = journeyStateData.journeyDetails.journeyId;
          companyIdObj.journeyName = journeyStateData.journeyDetails.journeyName;
          companyIdObj.loanTypeId = journeyStateData.journeyDetails.parentLoanId;
          companyIdObj.loanSubTypeId = journeyStateData.journeyDetails.loanSubTypeId;
          companyIdObj.employmentTypeId = journeyStateData.journeyDetails.employmentCategoryId;
          companyIdObj.employmentSubTypeId = journeyStateData.journeyDetails.employmentSubTypeId;
          companyIdObj.journeyTypeId = journeyStateData.journeyDetails.journeyTypeId;
          companyIdObj.targetAudienceTypeId = journeyStateData.journeyDetails.targetAudienceTypeId;
          companyIdObj.journeyDeploymentModeTypeId =
            journeyStateData.journeyDetails.journeyDeploymentModeTypeId;

          methodName = 'POST';
          endapiPath = 'journey/save-journey-loan-emp-selection';
        }
      } else if (type === 'journeyType') {
        methodName = 'GET';
        endapiPath = 'journey/master/types/journey-type';
      } else if (type === 'audienceType') {
        methodName = 'GET';
        endapiPath = 'journey/master/types/journey-target-audience-type';
      } else if (type === 'journeyDeploymentModeType') {
        methodName = 'GET';
        endapiPath = 'common/master-list/journey-deployment-mode-type/admin';
      }

      if (condition === 'get') {
        loanTypebycompany(type, methodName, endapiPath, '', token, '');
      } else {
        loanTypebycompany(type, methodName, endapiPath, JSON.stringify(companyIdObj), token, '');
      }
    },
    [LoginData]
  );

  const loanTypebycompany = async (type, method, endpoint, credentials, authToken, frmData) => {
    // setOpenLoader(true);
    const responseData = await CommonApiforJourney(
      method,
      endpoint,
      credentials,
      authToken,
      frmData
    );
    if (responseData.status === 'success') {
      // setOpenLoader(false);
      if (type === 'cardTypeList') {
        const storeData = { cardTypeList: null, cardNameList: [], cardContentList: [] };
        const resData = responseData.data.masterDataList;
        resData.forEach((resDataItem) => {
          resDataItem.isEnabled = true;
        });
        storeData.cardTypeList = resData;
        localStorage.setItem('cardTypeListAll', JSON.stringify(storeData));

        resData.forEach((item) => {
          const credObj = { typeId: item.typeId };
          if (JourneyEdit !== null) {
            if (JourneyEdit?.journeyModel?.journeyWizards.length > 0) {
              JourneyEdit?.journeyModel?.journeyWizards.forEach((journeyWizardsItem) => {
                credObj.wizardId = journeyWizardsItem.wizardId;
                loantyprapiFire('cardTypeName', JSON.stringify(credObj));
              });
            }
          } else {
            loantyprapiFire('cardTypeName', JSON.stringify(credObj));
          }
        });
      }
      if (type === 'cardTypeName') {
        let getstoreData = localStorage.getItem('cardTypeListAll');
        getstoreData = JSON.parse(getstoreData);
        const credentialsObj = JSON.parse(credentials);
        const resData = responseData.data.masterDataList;
        const cardTypeNameObj = { [credentialsObj.cardTypeId]: resData };
        getstoreData.cardNameList = [...getstoreData.cardNameList, cardTypeNameObj];
        localStorage.setItem('cardTypeListAll', JSON.stringify(getstoreData));

        if (resData.length > 0) {
          resData.forEach((item, index) => {
            const credObj = { cardMasterId: item.cardMasterId };
            if (JourneyEdit !== null) {
              if (JourneyEdit?.journeyModel?.journeyWizards.length > 0) {
                JourneyEdit?.journeyModel?.journeyWizards.forEach((journeyWizardsItem) => {
                  journeyWizardsItem.selectedCards.forEach((selectedCardsItem) => {
                    credObj.journeyCardId = selectedCardsItem.journeyCardId;
                    loantyprapiFire('cardNameList', JSON.stringify(credObj));
                  });
                });
              }
            } else {
              loantyprapiFire('cardNameList', JSON.stringify(credObj));
            }
          });
        }
      } else if (type === 'cardNameList') {
        let getstoreData = localStorage.getItem('cardTypeListAll');
        getstoreData = JSON.parse(getstoreData);
        const credentialsObj = JSON.parse(credentials);
        const resData = responseData.data.cardFields;
        resData.forEach((item) => {
          item.ocrDocumentMapping = ' ';
          item.ocrDocumentMappId = null;
          if (item.journeyCardDetailModel.cardDetailIsActive === null) {
            item.journeyCardDetailModel.cardDetailIsActive = false;
          }
        });
        const cardTypeNameObj = { [credentialsObj.cardMasterId]: resData };
        getstoreData.cardContentList = [...getstoreData.cardContentList, cardTypeNameObj];
        localStorage.setItem('cardTypeListAll', JSON.stringify(getstoreData));
      } else if (type === 'loanType') {
        const prevData = journeyStateData.journeyDetails;
        prevData.loanType = responseData.data.loanMasters;
        setJourneyStateData({
          ...journeyStateData,
          journeyDetails: prevData
        });
      } else if (type === 'loanSubType') {
        const prevData = journeyStateData.journeyDetails;
        prevData.loanSubType = responseData.data.loanTypes;
        setJourneyStateData({
          ...journeyStateData,
          journeyDetails: prevData
        });
      } else if (type === 'employmentType') {
        const prevData = journeyStateData.journeyDetails;
        prevData.employmentType = responseData.data.empTypes;
        setJourneyStateData({
          ...journeyStateData,
          journeyDetails: prevData
        });
      } else if (type === 'employmentSubType') {
        const prevData = journeyStateData.journeyDetails;
        prevData.employmentSubType = responseData.data.subEmpTypes;
        setJourneyStateData({
          ...journeyStateData,
          journeyDetails: prevData
        });
      } else if (type === 'journeyType') {
        const prevData = journeyStateData.journeyDetails;
        prevData.journeyType = responseData.data.masterDataList;
        setJourneyStateData({
          ...journeyStateData,
          journeyDetails: prevData
        });
      } else if (type === 'audienceType') {
        const prevData = journeyStateData.journeyDetails;
        prevData.targetAudience = responseData.data.masterDataList;
        setJourneyStateData({
          ...journeyStateData,
          journeyDetails: prevData
        });
      } else if (type === 'journeySave') {
        const JourneyObj = {
          journeyId: responseData.data.journeyId,
          employmentSubTypeId: responseData?.data?.employmentSubType?.employmentSubcategoryId,
          employmentCategoryId: responseData?.data?.employmentType?.employmentCategoryId,
          loanSubTypeId: responseData?.data?.loanSubType?.loanId,
          parentLoanId: responseData?.data?.loanType?.parentLoanId
        };
        localStorage.setItem('viewJourneyId', responseData.data.journeyId);
        localStorage.setItem('journeyDetailsId', JSON.stringify(JourneyObj));
        clearFormData();
        handleNext();
      } else if (type === 'journeyDeploymentModeType') {
        const prevData = journeyStateData.journeyDetails;
        prevData.journeyDeploymentModeType = responseData.data.masterTypes;
        prevData.journeyDeploymentModeType.forEach((item) => {
          if (item.typeCode === 'MOBILE') {
            prevData.journeyDeploymentModeTypeId = item.typeId;
            prevData.journeyDeploymentModeTypeName = JSON.stringify(item);
          }
        });
        setJourneyStateData({
          ...journeyStateData,
          journeyDetails: prevData
        });
      }
    } else if (responseData.status === 'error') {
      const prevData = journeyStateData.journeyDetails;
      prevData.errorMessage = responseData.description;
      prevData.errorPopUp = true;
      setJourneyStateData({
        ...journeyStateData,
        journeyDetails: prevData
      });
    }
  };

  const handleChange = (event, type) => {
    const prevData = journeyStateData.journeyDetails;
    let inputVal = '';
    if (type !== 'journeyName') {
      inputVal = JSON.parse(event.target.value);
    }
    if (type === 'journeyName') {
      prevData.journeyName = event.target.value;
    } else if (type === 'loanType') {
      prevData.parentLoanId = inputVal.parentLoanId;
      prevData.parentLoanName = event.target.value;
    } else if (type === 'loanSubType') {
      prevData.loanSubTypeId = inputVal.loanId;
      prevData.loanSubTypeName = event.target.value;
    } else if (type === 'employmentType') {
      prevData.employmentCategoryId = inputVal.employmentCategoryId;
      prevData.employmentCategoryName = event.target.value;
    } else if (type === 'employmentSubType') {
      prevData.employmentSubTypeId = inputVal.employmentSubcategoryId;
      prevData.employmentSubTypeName = event.target.value;
    } else if (type === 'journeyType') {
      prevData.journeyTypeId = inputVal.typeId;
      prevData.journeyTypeName = event.target.value;
      if (inputVal.typeCode !== 'RECOMMENDATION') {
        prevData.journeyDeploymentModeType = [];
        prevData.journeyDeploymentModeTypeId = null;
        prevData.journeyDeploymentModeTypeName = '';
        setJourneyStateData({
          ...journeyStateData,
          journeyDetails: prevData
        });
      } else {
        loantyprapiFire('journeyDeploymentModeType', 'get');
      }
    } else if (type === 'audienceType') {
      prevData.targetAudienceTypeId = inputVal.typeId;
      prevData.targetAudienceName = event.target.value;
    } else if (type === 'journeyDeploymentModeType') {
      prevData.journeyDeploymentModeTypeId = inputVal.typeId;
      prevData.journeyDeploymentModeTypeName = event.target.value;
    }

    setJourneyStateData({
      ...journeyStateData,
      journeyDetails: prevData
    });
  };

  const closePopUp = () => {
    const prevData = journeyStateData.journeyDetails;
    prevData.errorMessage = null;
    prevData.errorPopUp = false;

    setJourneyStateData({
      ...journeyStateData,
      journeyDetails: prevData
    });
  };

  const clearFormData = () => {
    setJourneyStateData({
      journeyDetails: {
        userId: null,
        companyId: null,
        journeyId: null,
        journeyName: null,
        parentLoanId: null,
        journeyIsActive: false,
        journeyIsPublish: false,
        parentLoanName: ' ',
        loanSubTypeId: null,
        loanSubTypeName: ' ',
        employmentCategoryId: null,
        employmentCategoryName: ' ',
        employmentSubTypeId: null,
        employmentSubTypeName: ' ',
        journeyTypeId: null,
        journeyTypeName: ' ',
        targetAudienceTypeId: null,
        targetAudienceName: ' ',
        journeyType: [],
        targetAudience: [],
        loanType: [],
        loanSubType: [],
        employmentType: [],
        employmentSubType: [],
        errorMessage: null,
        errorPopUp: false,
        landingType: []
      }
    });
  };

  return (
    <>
      <Box className="viewLeadCard">
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Journey Name
              </Typography>
              <TextField
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                value={journeyStateData.journeyDetails.journeyName}
                onChange={(event) => handleChange(event, 'journeyName')}
                placeholder="Type Journey Name"
              />
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Loan Type
              </Typography>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${journeyStateData.journeyDetails.parentLoanName}`
                }}
                disabled={JourneyEdit !== null}
                value={journeyStateData.journeyDetails.parentLoanName}
                onChange={(event) => {
                  const prevData = journeyStateData.journeyDetails;
                  prevData.loanSubTypeName = ' ';
                  setJourneyStateData({
                    ...journeyStateData,
                    journeyDetails: prevData
                  });

                  handleChange(event, 'loanType');
                  loantyprapiFire('loanSubType', journeyStateData.journeyDetails.parentLoanId);
                }}
              >
                <MenuItem value=" " disabled>
                  Select Loan Type
                </MenuItem>

                {journeyStateData.journeyDetails.loanType.map((loanItem, loanIndex) => (
                  <MenuItem key={`loanItem${loanIndex}`} value={JSON.stringify(loanItem)}>
                    {loanItem.parentLoanName}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Loan Sub Type
              </Typography>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${journeyStateData.journeyDetails.loanSubTypeName}`
                }}
                disabled={JourneyEdit !== null}
                value={journeyStateData.journeyDetails.loanSubTypeName}
                onChange={(event) => handleChange(event, 'loanSubType')}
              >
                <MenuItem value=" " disabled>
                  Select Loan Sub Type
                </MenuItem>
                {journeyStateData.journeyDetails.loanSubType.map((loanSubItem, loanSubIndex) => (
                  <MenuItem key={`loanSubItem${loanSubIndex}`} value={JSON.stringify(loanSubItem)}>
                    {loanSubItem.loanName}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Employment Type
              </Typography>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${journeyStateData.journeyDetails.employmentCategoryName}`
                }}
                disabled={JourneyEdit !== null}
                value={journeyStateData.journeyDetails.employmentCategoryName}
                onChange={(event) => {
                  const prevData = journeyStateData.journeyDetails;
                  prevData.employmentSubTypeName = ' ';
                  setJourneyStateData({
                    ...journeyStateData,
                    journeyDetails: prevData
                  });
                  handleChange(event, 'employmentType');
                  loantyprapiFire(
                    'employmentSubType',
                    journeyStateData.journeyDetails.employmentCategoryId
                  );
                }}
              >
                <MenuItem value=" " disabled>
                  Select Employment Type
                </MenuItem>
                {journeyStateData.journeyDetails.employmentType.map(
                  (employmentTypeItem, employmentTypeIndex) => (
                    <MenuItem
                      key={`employmentTypeItem${employmentTypeIndex}`}
                      value={JSON.stringify(employmentTypeItem)}
                    >
                      {employmentTypeItem.employmentCategoryName}
                    </MenuItem>
                  )
                )}
              </Select>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Employment Sub Type
              </Typography>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${journeyStateData.journeyDetails.employmentSubTypeName}`
                }}
                disabled={JourneyEdit !== null}
                value={journeyStateData.journeyDetails.employmentSubTypeName}
                onChange={(event) => handleChange(event, 'employmentSubType')}
              >
                <MenuItem value=" " disabled>
                  Select Employment Type
                </MenuItem>
                {journeyStateData.journeyDetails.employmentSubType.map(
                  (employmentSubTypeItem, employmentSubTypeIndex) => (
                    <MenuItem
                      key={`employmentSubTypeItem${employmentSubTypeIndex}`}
                      value={JSON.stringify(employmentSubTypeItem)}
                    >
                      {employmentSubTypeItem.employmentSubcategoryName}
                    </MenuItem>
                  )
                )}
              </Select>
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Journey Type
              </Typography>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${journeyStateData.journeyDetails.journeyTypeName}`
                }}
                value={journeyStateData.journeyDetails.journeyTypeName}
                onChange={(event) => handleChange(event, 'journeyType')}
              >
                <MenuItem value=" " disabled>
                  Select Journey Type
                </MenuItem>

                {journeyStateData.journeyDetails.journeyType.map(
                  (journeyTypeItem, journeyTypeItemIndex) => (
                    <MenuItem
                      key={`journeyTypeItem${journeyTypeItemIndex}`}
                      value={JSON.stringify(journeyTypeItem)}
                    >
                      {journeyTypeItem.typeName}
                    </MenuItem>
                  )
                )}
              </Select>
            </Box>
          </Grid>
          {journeyStateData.journeyDetails.journeyDeploymentModeType &&
            journeyStateData.journeyDetails.journeyDeploymentModeType.length > 0 && (
              <Grid item xs={4}>
                <Box className="">
                  <Typography variant="h6" className="formLabel">
                    Journey Deployment Mode
                  </Typography>
                  <Select
                    fullWidth
                    inputProps={{
                      className: `textInput customSelectBox dissabledMenu${journeyStateData.journeyDetails.journeyTypeName}`
                    }}
                    value={journeyStateData.journeyDetails.journeyDeploymentModeTypeName}
                    onChange={(event) => handleChange(event, 'journeyDeploymentModeType')}
                    disabled
                  >
                    {/* <MenuItem value=" " disabled>
                    Select Journey Type
                  </MenuItem> */}

                    {journeyStateData.journeyDetails.journeyDeploymentModeType.map(
                      (item, index) => (
                        <MenuItem
                          key={`journeyDeploymentTypeItem${index}`}
                          value={JSON.stringify(item)}
                        >
                          {item?.typeName}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </Box>
              </Grid>
            )}
          <Grid item xs={4}>
            <Box className="">
              <Typography variant="h6" className="formLabel">
                Target Audience
              </Typography>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${journeyStateData.journeyDetails.targetAudienceName}`
                }}
                value={journeyStateData.journeyDetails.targetAudienceName}
                onChange={(event) => handleChange(event, 'audienceType')}
              >
                <MenuItem value=" " disabled>
                  Select Target Audience
                </MenuItem>

                {journeyStateData.journeyDetails.targetAudience.map(
                  (targetAudienceItem, targetAudienceItemIndex) => (
                    <MenuItem
                      key={`targetAudienceItem_${targetAudienceItemIndex}`}
                      value={JSON.stringify(targetAudienceItem)}
                    >
                      {targetAudienceItem.typeName}
                    </MenuItem>
                  )
                )}
              </Select>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ display: 'flex', paddingTop: '1.5rem' }}>
        <Button
          onClick={() => loantyprapiFire('journeySave', '')}
          className="mainBtn nextBtn"
          endIcon={<HiOutlineArrowNarrowRight />}
          variant="contained"
        >
          Next
        </Button>
      </Box>

      <Dialog
        open={journeyStateData.journeyDetails.errorPopUp}
        onClose={closePopUp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {journeyStateData.journeyDetails.errorMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closePopUp}>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
